import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["scopes", "gates"];
import { createContext, useContext, useMemo } from 'react';

/**
 * raw permission information on CrmObjects, both user and hubspot defined */

/**
 * Context for providing permission information on CrmObjects, both user and hubspot defined */
import { jsx as _jsx } from "react/jsx-runtime";
export const PermissionsContext = /*#__PURE__*/createContext({});
export function PermissionsProvider({
  children,
  values
}) {
  const value = useMemo(() => {
    const {
        scopes,
        gates
      } = values,
      rest = _objectWithoutPropertiesLoose(values, _excluded);
    return Object.assign({}, rest, {
      scopes: new Set(Array.isArray(scopes) ? scopes : []),
      gates: new Set(Array.isArray(gates) ? gates : [])
    });
  }, [values]);
  return /*#__PURE__*/_jsx(PermissionsContext.Provider, {
    value: value,
    children: children
  });
}
export const usePermissionsContext = () => useContext(PermissionsContext);